module.exports = __webpack_public_path__ + "static/media/slider2.0f64e2d3.jpg";